import React from 'react';
import PropTypes from 'prop-types';
import Form from '../form/Form';

const layout = [
  {
    name: 'folder',
    label: 'Folder Name',
    required: true,
  },
];

const NewFolder = ({ initialValue = '', onCancel, onSubmit }) => {
  layout[0].data = initialValue;

  return (
    <Form
      layout={[...layout]}
      exportFormat="object"
      submit={onSubmit}
      onCancel={onCancel}
      trackDirty={!!initialValue}
    />
  );
};

NewFolder.propTypes = {
  initialValue: PropTypes.string,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default NewFolder;
